import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from "react-bootstrap";
import UiUtils from '../../../../utils/UiUtils';
import ApiClient from '../../../../utils/ApiClient';
import ResultadoBusqueda from './components/ResultadoBusqueda';
import '../../../../css/busqueda.css';
import {
    RESULTS_PER_PAGE
}
from '../../../../config';

class AutomoresBusqueda extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tipo: props.tipo,
      valor: props.valor,
      resultados_busqueda: {
        titular_actual:[],
        titular_historial:[]
      },
      totalSize: 0,
      currentPage: 0
    }
  }

  componentDidMount() {
    this.onBusquedaHandler(1);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      tipo: nextProps.tipo,
      valor: nextProps.valor
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.tipo !== prevState.tipo || this.state.valor !== prevState.valor)
      this.onBusquedaHandler(1);
  }

  onBusquedaHandler = (page) => {
    UiUtils.showProgress(true);
    ApiClient.searchCarOwners(this.state.tipo, this.state.valor, page, RESULTS_PER_PAGE)
      .then(this.onFinishSearch)
      .then((res) => {
        this.setState({
          currentPage: page,
          resultados_busqueda: res.data,
          totalSize: res.total_page
        });
      })
      .catch(function (error) {
        UiUtils.showProgress(false);
        UiUtils.showError(error);
        UiUtils.navigateTo('/dashboard/automotores/busqueda/');
      });
  }

  onPageChange = (page, sizePerPage) => {
    this.onBusquedaHandler(page);
  }

  onFinishSearch = (res) => {
    UiUtils.showProgress(false);
    if (res.result.code === 200) {
      if (res.data.titular_actual.length) {
        return res;
      } else {
        throw UiUtils.handledError("No se han encontrado resultados que coincidan con su criterio de búsqueda");
      }
    } else {
      throw UiUtils.handledError(res.result.info);
    }
  }

  render() {

    const panel_title = (
      <h2><i className="fa fa-search"></i>  Resultados de la búsqueda</h2>
    )

    return (
      <div className="resultado-busqueda -seleccionable">
        <h1>Búsqueda de titulares</h1>
        <Panel header={panel_title}>
          <h2>Titular actual</h2>
          <ResultadoBusqueda 
            onResultadoSeleccionado={this.props.onResultadoSeleccionado}
            datos={this.state.resultados_busqueda.titular_actual} 
            onPageChange={this.onPageChange}
            currentPage={this.state.currentPage} 
            totalDataSize={this.state.totalSize} 
          />

        <h2>Historial de titulares</h2>
          <ResultadoBusqueda 
            onResultadoSeleccionado={this.props.onResultadoSeleccionado}
            datos={this.state.resultados_busqueda.titular_historial} 
            onPageChange={this.onPageChange}
            currentPage={this.state.currentPage} 
            totalDataSize={this.state.totalSize} 
          />
        </Panel>
      </div>
    );
  }

  static propTypes = {
    onResultadoSeleccionado: PropTypes.func,
    tipo: PropTypes.string.isRequired,
    valor: PropTypes.string.isRequired
  }
}

export default AutomoresBusqueda;



// WEBPACK FOOTER //
// ./src/scenes/automotores/components/automotores-busqueda/AutomoresBusqueda.js